"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils = /** @class */ (function () {
    function StringUtils() {
    }
    StringUtils.stringIsNullOrEmpty = function (str) {
        return !(str && str.length);
    };
    StringUtils.stringTrimEnd = function (str, char) {
        if (!this.stringIsNullOrEmpty(str)) {
            if (str.endsWith(char)) {
                str = str.slice(0, -1);
            }
        }
        return str;
    };
    StringUtils.stringTrimStart = function (str, char) {
        if (!this.stringIsNullOrEmpty(str)) {
            if (str.startsWith(char)) {
                str = str.substr(1);
            }
        }
        return str;
    };
    StringUtils.stringTrim = function (str, char) {
        str = this.stringTrimEnd(str, char);
        str = this.stringTrimStart(str, char);
        return str;
    };
    StringUtils.concat = function (str1, sep, str2) {
        str1 = this.stringTrimEnd(str1, sep);
        str2 = this.stringTrimStart(str2, sep);
        return str1.concat(sep, str2);
    };
    StringUtils.replaceRnToBr = function (txt) {
        if (this.stringIsNullOrEmpty(txt)) {
            return '';
        }
        return txt.replace(/(?:\r\n|\r|\n)/g, '<br />');
    };
    return StringUtils;
}());
exports.default = StringUtils;
//# sourceMappingURL=string_utils.js.map